<template>
  <nav class="navigation">
    <button class="navi-btn open-navigation" aria-label="Odpri meni z navigacijo" data-string-close="Zapri navigacijo"
      data-string-open="Odpri navigacijo" @click.prevent="openMenu">

      <span class="visuallyhidden">Odpri navigacijo</span>
    </button>
    <div :class="innerOpen()">
      <button aria-label="Zapri meni z navigacijo" type="button"
        class="close-navigation-btn close-popup-btn close-navigation" tabindex="-1" @click.prevent="closeMenu">
        <span class="visuallyhidden">Zapri menu</span>
      </button>
      <div class="menus">

        <!-- dynamic menu-->
        <ul class="menu primary">
          <li>
            <a href="home" @click.prevent="updateMenu('')" :class="highlightSection('home')">
              <font-awesome-icon icon="home" />
              Domov
            </a>
          </li>
          <li>
            <a href="inputi" @click.prevent="updateMenu('inputi')" :class="highlightSection('inputi')">
              <font-awesome-icon icon="flask" />
              Seznam inputov
            </a>
          </li>

        </ul>
        <!-- login status and info spacer + user name + nek info o prijavi/vlogi in odjava-->

        <ul v-if="!status.loggedIn" class="prijava menu">
          <li>
            <a href="/login" @click.prevent="updateMenu('login')" :class="highlightSection('login')">
              <font-awesome-icon icon="user" />
              Prijava
            </a>
          </li>

        </ul>
        <ul v-else class="prijavljen menu">

          <li v-for="menuItem in menu">



            <a :href="'/' + menuItem.name" @click.prevent="updateMenu(menuItem.name)"
              :class="highlightSection('menuItem.name')">
              <font-awesome-icon :icon="menuItem.icon" />

              {{ menuItem.text }}
            </a>

            <ul v-if="menuItem.submenu" class="submenu">
              <li v-for="submenuItem in menuItem.submenu">
                <a :href="'/' + submenuItem.name" @click.prevent="updateMenu(submenuItem.name)"
                  :class="highlightSection('submenuItem.name')">
                  <font-awesome-icon :icon="submenuItem.icon" />
                  {{ submenuItem.text }}
                </a>
              </li>
            </ul>

          </li>





          <li class="uporabnik-spacer"></li>

          <li class="uporabnik ">{{ userDetails.ime }} {{ userDetails.priimek }}</li>
          <li class="uporabnik">{{ userDetails.organizacija }}</li>
        </ul>
      </div>
    </div>

  </nav>




  
</template>

<script>
import menuData from './support/menu-data';
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Menu',

  data() {
    return {
      contextSection: '',

      menuItems: [],

      menuData: menuData,

      activeSubMenu: '',
      menuOpened: false,

    }
  },
  created() {
    if (localStorage.getItem('user')) {
      console.log(this.menu);
      this.getLoggedIn()
        .then(f => this.getMenu())
        .then(f => console.log(this.menu));



    }


  },
  methods: {

    openProjectLink() {
      alert('You could open the project frontend in another tab here, so the logged admin could see changes made to the project ;)');
    },

    updateMenu(context) {
      this.contextSection = context;
      //this.menuItems = this.menuData[context];

      this.menuOpened = false;
      this.$router.push("/" + context);
      //window.bus.$emit('menu/closeMobileMenu');

    },

    highlightSection(section) {

      return {
        'link': true,
        'link-active': section === this.contextSection,
      };
    },
    innerOpen() {
      return {
        'inner': true,
        'navi-is-open': this.menuOpened,
      };
    },
    openMenu() {
      this.menuOpened = true;
    },
    closeMenu() {
      this.menuOpened = false;
    },

    ...mapActions('users', ['getLoggedIn', 'getMenu']),

  },

  computed: {
    showContextMenu() {
      return this.menuItems.length;
    },
    ...mapState('account', ['status']),
    ...mapState('users', ['userDetails', 'menu'])
  }

}
</script>
